/**
 * External Dependencies
 */
import $ from 'jquery'
import fancybox from '@fancyapps/fancybox'



$(() => {




  //Main Menu open/close
  $('.menu-open').on('click', function(e) {
    $('.overlay-menu').css('width','100%');
    e.preventDefault();
  });
  $('.menu-close').on('click', function(e) {
    $('.overlay-menu').css('width','0%');
    e.preventDefault();
  });


  //Accordion
  $(".accordion-head").on('click', function(e) {
    $(".accordion-head").removeClass('accordion-head-open');
    $(this).addClass('accordion-head-open');
    if ($('.accordion-body').is(':visible')) {
      $(".accordion-body").slideUp(300);
      $(".plusminus").text('+');
    }
    if ($(this).next(".accordion-body").is(':visible')) {
      $(this).next(".accordion-body").slideUp(300);
      $(this).children(".plusminus").text('+');
    } else {
      $(this).next(".accordion-body").slideDown(300);
      $(this).children(".plusminus").text('-');
    }
    e.preventDefault();
  });

  //scroll to
	$(".scroll").on('click', function(e) {
	  e.preventDefault();
	  $('html,body').animate({scrollTop:$(this.hash).offset().top}, 800);
	});

  //Avvio la chat PING sulla classe
	$('.avvia-chat').on('click', function(e) {
    $('html,body').animate({scrollTop: 0}, 800);
		Common.showWidgetFromCircle(); //chiamata awhy
		$('.visibile-ritardo').fadeOut(200);
		$('.mostra-robot').animate({
		  right:"-80px",
		});
	});
  //Avvio la chat PING sull'href
  $('a[href="#avvia-chat"]').on('click', function(e) {
    e.preventDefault(); // Previene l'azione di default del link

    Common.showWidgetFromCircle(); //chiamata awhy

    $('html,body').animate({scrollTop: 0}, 800);
  });


  //Avvio la chat PING su azione specifica con classe
  function aggiungiClassiAiLinkChat() {
    $('a[href^="#avvia-chat-specifica-"]').each(function() {
        // Estrai il nome della classe dall'href
        var nomeClasse = $(this).attr('href').replace('#avvia-chat-specifica-', '');

        // Aggiungi la classe all'elemento <a> (se nomeClasse non è vuoto)
        if (nomeClasse) {
            $(this).addClass(nomeClasse);
        }
    });
  }
  aggiungiClassiAiLinkChat();
  $('a[href^="#avvia-chat-specifica-"]').on('click', function(e) {
      e.preventDefault(); // Previene l'azione di default del link

      Common.showWidgetFromCircle();

      // Anima lo scroll verso l'alto della pagina
      $('html,body').animate({scrollTop: 0}, 800);
  });





  //scroll al form
  $('a[href="#contact-form"]').on('click', function(e) {
    e.preventDefault();
    $('html,body').animate({scrollTop:$(this.hash).offset().top}, 800);
  });

  // form popup
  $('a[href="#contact-form-popup"]').on('click', function(e) {
    e.preventDefault();
    $.fancybox.open( $('#contact-form-popup'), {
      touch: false
    });
  });

  // nascondo il chatbot in basso
  $('.nascondi-robot').on('click', function(e) {
    $('.visibile-ritardo').fadeOut(200);
    $('.mostra-robot').animate({
      right:"-80px",
    });
  });
  //mostro il chatbot in basso
	$('.mostra-robot').on('click', function(e) {
    $('.visibile-ritardo').fadeIn(200);
    $('.mostra-robot').animate({
      right:"0px",
    });
  });
  //suono
  $(window).load(function(){
		var suonoChat = document.getElementById('sound1');
		setTimeout(function(){

			$('.customchatbot-float img').fadeIn(500);
			$('.visibile-ritardo').delay(500).fadeIn(500);
			//suonoChat.play();

		}, 2000);

	});

})
